module.exports = __webpack_public_path__ + "static/media/Gabriella Cau.592b976b.png";